import { event } from "@zillow/universal-analytics";
function sendEvent(triggerSource, label, url, cmsInfo) {
  event({
    // https://dataportal.zillowgroup.net/event-registry/2048
    envelope: {
      event_type_id: "2048",
      event_type_version_id: "3",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: triggerSource,
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_click"
    },
    cms_info: {
      block_type_cd: "MainNav",
      block_displayed_txt: label,
      block_target_url: url,
      block_target_window_txt: "",
      ...cmsInfo
    }
  });
}
function getMobileNavMode({
  sticky,
  mobileMenu
}) {
  if (mobileMenu) {
    return "menu";
  }
  if (sticky) {
    return "sticky";
  }
  return "inFlow";
}
const B2B_MOBILE_MENU_TOP_PX = 41;
function getMobileMenuTopPx(headerTop) {
  return Math.max(B2B_MOBILE_MENU_TOP_PX, -headerTop);
}
export {
  B2B_MOBILE_MENU_TOP_PX,
  getMobileMenuTopPx,
  getMobileNavMode,
  sendEvent
};
